module.exports = __webpack_public_path__ + "static/media/PDF_Icon.6f947346.svg";